module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1 mt"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Other Books by Laura Joffe Numeroff")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2 mt"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("If You Give a Dog a Donut")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("If You Give a Moose a Muffin")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("If You Give a Mouse a Brownie")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("If You Give a Mouse a Cookie")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("If You Give a Pig a Pancake")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("If You Give a Pig a Party")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("If You Take a Mouse to the Movies")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("If You Take a Mouse to School")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2 mt"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Ponyella")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("When Sheep Sleep")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Beatrice Doesn’t Want To"), _c('br'), _vm._v("Lots of Lambs")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2 mt"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Jellybeans and the Big Kickoff")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Jellybeans and the Big Dance")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Jellybeans and the Big Book Bonanza"), _c('br'), _vm._v("The Jellybeans and the Big Art Adventure")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1m"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "alt": "",
      "src": "image/cookies.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('a', {
    attrs: {
      "id": "title"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-3 mt"
  }, [_c('a', {
    attrs: {
      "id": "copy"
    }
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("If You Give a Man a Cookie: A Parody ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("copyright © 2017 by Laura Joffe Numeroff. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Illustrations copyright © 2017 Brian Ajhar. All rights reserved. No part of this book may"), _c('br'), _vm._v(" be used or reproduced in any manner whatsoever without written permission except"), _c('br'), _vm._v(" in the case of reprints in the context of reviews. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3 mt"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andrews McMeel Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("a division of Andrews McMeel Universal")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("1130 Walnut Street, Kansas City, Missouri 64106")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3 mt"
  }, [_c('a', {
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("www.andrewsmcmeel.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3 mt"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("ISBN: 978-1-4494-8554-2")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3 mt"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Editor: Patty Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Art Director: Holly Swayne")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Production Editor: Erika Kuster")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Production Manager: Tamara Haus")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Digital Production: Kristen Minter")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3 mt"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Attention: Schools and Businesses")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase "), _c('br'), _vm._v("for educational, business, or sales promotional use. For information, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("please e-mail the Andrews McMeel Publishing Special Sales Department: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "mailto:specialsales@amuniversal.com"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("specialsales@amuniversal.com")])]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "p1 ParaOverride-3 mt"
  }, [_c('a', {
    attrs: {
      "id": "ded"
    }
  }), _c('span', {
    staticClass: "s1 CharOverride-6"
  }, [_vm._v("For Kathleen—thank you for your help and patience, "), _c('br'), _vm._v("but most of all, thank you for your friendship.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1 ParaOverride-4"
  }, [_c('span', {
    staticClass: "s1 CharOverride-6"
  }, [_vm._v("—Laura Numeroff")])]), _vm._v(" "), _c('p', {
    staticClass: "p1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("To my wife, Pamela, who has always been there for me ")])]), _vm._v(" "), _c('p', {
    staticClass: "p1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("and also makes the best cookies.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1 ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("—Brian Ajhar")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1m"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "alt": "",
      "src": "image/NEW.EXTRA.SOFA.wDOG.TOY.400p.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/blank.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    staticStyle: {
      "margin-top": "20%"
    },
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("If you give a man a cookie,")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-6-7final.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-6-7final1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("he’ll ask for some milk to go with it.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-8-9final.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("God forbid he should get it himself.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-8-9final1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("When he’s done")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(", he’ll put the empty carton "), _c('br'), _vm._v("back in the refrigerator.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-10final.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("He’ll probably want to see if there’s any milk in his mustache.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-11FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-12final.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-3 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("When he’s looking at his mustache in the bathroom mirror,  he’ll worry that his hairline is starting to recede.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("He might freak out "), _c('br'), _vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("ask you for a ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("comb.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-13final.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("When you bring him the comb,  you’ll trip on the wet towels  he left on the floor.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-14-15FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-16FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("He’ll try combing his hair to hide what he thinks "), _c('br'), _vm._v("is a receding hairline.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-17final.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "Normal mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("He might feel old, so he’ll suck in his stomach, ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-18.FINAL_A.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("flex his muscles ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-18FINAL_B.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-18FINAL_C.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-7b mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("and try to do ten pushups.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-19FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After he’s done three pushups, he’ll be so tired, "), _c('br'), _vm._v("h")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("e’ll ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("lie down on the couch on top of the laundry ")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("you just folded.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Then he’ll want to watch TV so he’ll ask you for the remote. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-20FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-21final.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("While")]), _c('span', {
    staticClass: "CharOverride-9"
  }), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("he’s flipping")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("through 200 channels, "), _c('br'), _vm._v("he might ")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("find a fishing show.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("It will remind him that he should go fishing again.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-22final.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-23FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("You’ll leave the room before he can ask you "), _c('br'), _vm._v("where his tackle box is. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("He’ll probably fall asleep watching TV.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-24FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("He might snore so loud, he’ll wake himself up.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer045"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-25final.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer048"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("So he’ll go upstairs and get ready for bed. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer047"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-26FINAL.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer050"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("When he gets into bed, he’ll stare at you "), _c('br'), _vm._v("and ask if you’re sleeping. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer049"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-27FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer051"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-28final.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer053"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("He’ll toss")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-28final1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-29final1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer056"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("and turn.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer054"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/PG-29final.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer058"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Then he’ll roll over and take all of the blankets with him.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer057"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-30FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer060"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("When he")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" can’t fall asleep, he’ll ask for some milk.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer059"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-31FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer061"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("And, chances are if he asks for some milk,")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer063"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6 mt"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("you’ll tell him to drag his sorry ass out of bed and get it himself.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer062"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/PG-32FINAL.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/blank.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    staticStyle: {
      "margin-top": "15%"
    },
    attrs: {
      "id": "_idContainer064"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('a', {
    attrs: {
      "id": "aut"
    }
  }), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Laura Numeroff")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("is the author of ")]), _c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("If You Give a Mouse a Cookie, Lots of Lambs,")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" and a whole bunch of other books.")]), _c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v(" She grew up in Brooklyn but lives in Los Angeles, where she enjoys the smog. She is crazy about making Jiffy Pop, crocheting hats for porcupines,")]), _c('span', {
    staticClass: "CharOverride-14",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("and is currently working on a Pop-Tart pop-up book.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("brian ajhar")]), _c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("’s world is one of quirky characters with questionable qualities. His illustrations for books and magazines are beloved worldwide, and a few have been hits on other planets. In his downtime, he can be found on the golf course, searching for his lost ball, which he will never find. Brian currently works as a character designer for television commercials and animated feature films.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1m"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer065"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "alt": "",
      "src": "image/FlapArt.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db757fb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CookieMan_kindle.vue
// module id = 57
// module chunks = 0